import { NgModule } from '@angular/core';
import { UpdateNativeAlertComponent } from './update-native-alert.component';

@NgModule({
  declarations: [UpdateNativeAlertComponent],
  exports: [UpdateNativeAlertComponent],
})
export class UpdateNativeAlertModule {}
